import React, { useCallback, useState } from "react";
import debounce from "lodash.debounce";
import AsyncSelect from "react-select/async";
import { useSelector } from "react-redux";
import { getBaseUrl } from "../reducers";
import { searchUsersForImpersonation, startImpersonation } from "requesters/impersonationRequester";

const ImpersonationSelect = () => {
  const baseUrl = useSelector(getBaseUrl)
  const canImpersonate = useSelector(state => state.config.can_impersonate)
  const impersonating = useSelector(state => state.config.impersonating)
  const [starting, setStarting] = useState(false)

  const loadOptions = (inputValue, callback) => {
    const query = (inputValue || "").trim()
    if (query.length < 2) {
      callback([])
      return
    }

    searchUsersForImpersonation(baseUrl, query, 1)
      .then(res => {
        if (res.error || !res.response) {
          callback([])
          return
        }
        callback(res.response.map(user => ({
          value: user.id,
          label: [user.name, user.email, user.default_role].filter(Boolean).join(" — ")
        })))
      })
      .catch(() => callback([]))
  }

  const debouncedLoadOptions = useCallback(debounce(loadOptions, 300), [baseUrl])

  if (!canImpersonate || impersonating) return null

  const handleChange = option => {
    if (!option || starting) return
    setStarting(true)
    startImpersonation(baseUrl, option.value)
      .then(res => {
        if (res.status === 200 || res.status === 201) {
          window.location.assign("/")
          return
        }
        setStarting(false)
      })
      .catch(() => setStarting(false))
  }

  return (
    <div className="impersonation-select mr-3" style={{ width: 280 }}>
      <AsyncSelect
        cacheOptions
        loadOptions={debouncedLoadOptions}
        onChange={handleChange}
        placeholder="Impersonate user..."
        isDisabled={starting}
        isClearable
        noOptionsMessage={({ inputValue }) => (
          (inputValue || "").trim().length < 2 ? "Type at least 2 characters" : "No users found"
        )}
      />
    </div>
  )
}

export default ImpersonationSelect
